import Prismic from "prismic-javascript";
import { apiEndpoint, accessToken } from "../prismic-configuration";

export const client = Prismic.client(apiEndpoint, { accessToken });



// WEBPACK FOOTER //
// ./src/utils/prismicHelpers.js